export const ESGA_AUTO_SAVE_INTERVAL = 10_000;
